import ErrorMessage from '@/form/ErrorMessage'

function PaymentMethodError() {
  return <ErrorMessage name="payment_method" />
}

export default PaymentMethodError
